<template>
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <p class=".title ma-2">Add an activity to {{ hspl.plan_code }} </p>
            <v-form ref="updPlan" v-model="updPlanValid">
                <v-row v-if="hspl.huis_combi > ''" no-gutters>
                    <v-col>
                        <v-alert border="left" type="warning" class="ma-2">
                            Attention: Combi Accommodation
                        </v-alert>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col>
                        <v-alert border="left" type="warning" class="ma-2">
                            Attention: For host booking use "add host booking" button
                        </v-alert>
                    </v-col>
                </v-row>
                
                <v-row no-gutters>
                    <v-col class="ma-2 px-2">
                        <v-select v-model="hspl.plan_item" :items="plan_itemKeuzes" label="Add to planning"
                            :rules="plan_itemRules"></v-select>
                    </v-col>
                </v-row>

                <v-row no-gutters class="px-2">
                    <!-- <v-col cols="6" class="pl-2 pr-4">
                        <v-menu v-model="hspl.plan_item_van_datMenu" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" readonly offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="hspl.plan_item_van_dat" label="Start date" v-on="on"
                                    dense></v-text-field>
                            </template>
                            <v-date-picker v-model="hspl.plan_item_van_dat2" :first-day-of-week="1"
                                @input="hspl.plan_item_van_dat = $moment(hspl.plan_item_van_dat2).format('DD-MM-YYYY'); hspl.plan_item_van_datMenu = false"></v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col cols="6" class="pl-2 pr-4">
                        <v-menu v-model="hspl.plan_item_tm_datMenu" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" readonly offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="hspl.plan_item_tm_dat" label="End date" v-on="on"
                                    dense></v-text-field>
                            </template>
                            <v-date-picker v-model="hspl.plan_item_tm_dat2" :first-day-of-week="1"
                                @input="hspl.plan_item_tm_dat = $moment(hspl.plan_item_tm_dat2).format('DD-MM-YYYY'); hspl.plan_item_tm_datMenu = false"></v-date-picker>
                        </v-menu>
                    </v-col> -->
                    <v-col cols="6" class="pa-2">
                        <date_picker label="Date from"                                 
                                     :date="hsplFromDate"
                                     :startDate="hsplFromDate"
                                     field="hsplFromDate" 
                                     icon="mdi-calendar-month-outline"
                                     @updateData="updateData"/> 
                    </v-col>
                    <v-col cols="6" class="pa-2">
                        <date_picker label="Date until"                                 
                                     :date="hsplUntilDate"
                                     :startDate="hsplFromDate"
                                     field="hsplUntilDate" 
                                     icon="mdi-calendar-month-outline"
                                     @updateData="updateData"/> 
                    </v-col>

                </v-row>

                <v-row v-if="hspl.plan_item === 'Waiting'" no-gutters>
                    <v-col class="ma-2 px-2">
                        <v-select v-model="hspl.plan_aant_dag" :items="aant_dagKeuzes"
                            label="Waiting for number of days"></v-select>
                    </v-col>
                </v-row>

                <v-row v-if="hspl.plan_item === 'Host booking'" no-gutters>
                    <v-col class="ma-2 px-2">
                        <guest :isShortVersion="true" :isDense="true" :guest="guest" @updateData="updateData"/>  
                    </v-col>                         
                </v-row>

                <v-row v-if="hspl.plan_item === 'Host booking'" no-gutters>                      
                    <v-col class="ma-2 px-2">
                        <travelparty :isShortVersion="true" :numRowsRemark="2" :travelparty="travelparty" @updateData="updateData"/>
                    </v-col>               
                </v-row>
                <v-row v-if="standard_period_check" no-gutters>
                    <v-col>
                        <v-alert border="left" type="error" class="ma-2">
                            This is not a standard bookable period, are you sure you want to add this period?
                            <v-checkbox v-model="overrule_check" label="Yes I understand, please add this period anyway."></v-checkbox>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="updPlan" :disabled="!updPlanValid">Save</v-btn>
                <v-btn color="primary" small @click="overrule_check = false; standard_period_check = false; dialog = false;">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import travelparty from '@/components/plan/hpbz/travelparty.vue'
import guest from '@/components/plan/hpbz/guest.vue'
import date_picker from '@/components/ui/date_picker.vue';

export default {

    components: {
        travelparty,
        guest,
        date_picker
    },
    data() {
        return {
            dialog: false,
            updPlanValid: false,
            hspl_encrid: null,
            plan_code: '',
            hspl: {},
            hsplFromDate: null, 
            hsplUntilDate: null,
            travelparty: {adults: '0', children: '0', babys: '0', pets: '0', remark: ''},
            guest: { name: '', email: '', telephone: '', address: '', city: '' },
            plan_itemKeuzes: [],
            aant_dagKeuzes: [],
            plan_itemRules: [
                v => (v && v.length >= 3) || "A choice is required"
            ],
            standard_period_check: false,
            overrule_check:false,
        }
    },
    methods: {
        // updateData(data){
        //     console.log('updateData', data);
        //     this[data.field] = data.value;
        // },        
        open(datum, hspl_encrid) {
            var deze = this;
            this.dialog = true;
            
            if(datum!==null&&datum!==''){
                this.hsplFromDate=datum 
                this.hsplUntilDate=datum
            }

            this.$axios
                .post("ares/json/ares/huis/hspl/getHsplToUpdPlan.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHsplToUpdPlan"
                    },
                    getHsplToUpdPlan: {
                        hspl_encrid: hspl_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {

                        this.hspl = res.data.getHsplToUpdPlan;
                        this.hspl.plan_item_van_dat2 = datum;
                        this.hspl.plan_item_van_dat = this.$moment(datum).format('DD-MM-YYYY');
                        this.hspl.plan_item_tm_dat2 = datum;
                        this.hspl.plan_item_tm_dat = this.$moment(datum).format('DD-MM-YYYY');

                        res.data.getHsplToUpdPlan.plan_itemKeuzes.forEach(function (items) {
                            deze.plan_itemKeuzes.push(items);
                        });
                        res.data.getHsplToUpdPlan.aant_dagKeuzes.forEach(function (dag) {
                            deze.aant_dagKeuzes.push(dag);
                        });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        updateData(data){
            this[data.field] = data.value;
        },
        closeDialog(){
            this.travelparty = {adults: '0', children: '0', babys: '0', pets: '0', remark: ''};
            this.guest = { name: '', email: '', telephone: '', address: '', city: '' };
            this.$emit("reloadHuis");
            this.overrule_check = false;
            this.standard_period_check = false;
            this.dialog = false;
        },
        updPlan() {
            this.$axios
                .post("ares/json/ares/huis/hspl/updPlan.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updPlan"
                    },
                    updPlan: {
                        hspl_encrid: this.hspl.hspl_encrid,
                        plan_item: this.hspl.plan_item,
                        plan_item_van_dat: this.$moment(this.hsplFromDate).format('DD-MM-YYYY'),  //this.hspl.plan_item_van_dat,
                        plan_item_tm_dat: this.$moment(this.hsplUntilDate).format('DD-MM-YYYY'), //this.hspl.plan_item_tm_dat,
                        plan_aant_dag: parseInt(this.hspl.plan_aant_dag),
                        travelparty: this.travelparty,
                        overrule_check: this.overrule_check,
                        guest: this.guest
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        if (res.data.updPlan.standard_period_check){
                            this.standard_period_check = res.data.updPlan.standard_period_check
                        }
                        else {
                            this.$store.dispatch('setSnackbar', {
                                showing: true,
                                text: res.data.updPlan.text,
                                color: res.data.updPlan.color
                            });
                            this.overrule_check = false;
                            this.standard_period_check = false;
                            this.closeDialog();
                            // this.dialog = false;
                            // if (res.data.updPlan.color == "success") {
                            //     //this.$router.reload('/huis/onHuis/' + res.data.updPlan.huis_encrid);   
                            //     bus.$emit("closeDialog", "reload");
                            // }
                        }
                        
                    }
                })
        },
    }
}
</script>

